import routes from './routes.constants';
import { waitForGrowthbookInit } from '../plugins/growthbook/growthbook';

// Consumables A/B: /buy-super-interest is the Superintresse purchase page
// the app opens in its web view. Superintresse is the variant's, so the
// control group is sent to the swap list instead of being sold super likes.
// Same shape as boostSummaryGuard: GrowthBook may still be initialising,
// and the store is loaded when the guard runs, not with the route table.
export async function buySuperInterestGuard(to, from, next) {
  await waitForGrowthbookInit();
  const { default: store } = await import('../store/store');

  if (store.getters['app/isTestEnabled']('consumables')) {
    next();
    return;
  }

  next({ path: routes.SWAP_LIST, replace: true });
}
